<template>
    <span class="relative align-middle" @click="open('click')" @mouseenter="open('hover')" @mouseleave="mouseleave">
        <slot v-if="this.$slots.default"></slot>
        <svg v-else class="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.501 3.501 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2v-.645z"/></svg>
        <div v-if="content" :class="[
            this.$slots.default ? '' : '-ml-4',
            show === true ? 'flex' : 'hidden',
            position === 'right' ? 'absolute top-1/2 left-full ml-2 flex-row items-center z-50 -translate-y-1/2' : '',
            position === 'top' ? 'absolute bottom-0 flex-col items-center mb-6 -left-14 -right-14 z-50' : '',
            position === 'bottom' ? 'absolute top-full mt-2 flex-col items-center -left-14 -right-14 z-50' : '',
            position === 'left' ? 'absolute top-1/2 right-full mr-2 flex-row items-center z-50 -translate-y-1/2' : ''
        ]">
            <div v-if="position === 'right'" class="bg-black h-3 w-3 -mr-2 flex-shrink-0" style="transform: rotate(225deg);"></div>
            <span v-if="showContentWithNewLines"
                  :class="[
                      'bg-black leading-none p-2 relative rounded shadow-lg text-white text-xs whitespace-no-wrap z-10'
                  ]"
                  style="max-width: 300px;"
                  v-html="content"
            />
            <span v-else :class="[
                'bg-black leading-none p-2 relative rounded shadow-lg text-white text-xs whitespace-no-wrap z-10'
            ]" style="max-width: 300px;">{{ content }}</span>
            <div v-if="position !== 'right'" :class="[
                'bg-black h-3 transform w-3',
                position === 'left' ? '-ml-2 rotate-[135deg]' : '',
                position === 'top' ? '-mt-2 rotate-45' : '',
                position === 'bottom' ? 'mt-2 rotate-45' : '',
                arrowClasses
            ]"></div>
        </div>
    </span>
</template>
<script>
    // Only one tooltip may be visible at a time. Adjacent triggers can swallow each
    // other's mouseleave, so opening one force-closes whichever was open before.
    let activeTooltip = null;

    export default {
        props: {
            content: String,
            method: {
                default: 'hover'
            },
            showContentWithNewLines: {
                default: false
            },
            arrowPosition: {
                type: String,
                default: 'center',
                validator: function (value) {
                    return ['left', 'center', 'right'].indexOf(value) !== -1
                }
            },
            position: {
                type: String,
                default: 'top',
                validator: function (value) {
                    return ['top', 'right', 'bottom', 'left'].indexOf(value) !== -1
                }
            }
        },
        data() {
            return {
                show: false,
                hoverTimeout: null,
                hideTimeout: null
            }
        },
        computed: {
            arrowClasses() {
                return {
                    'tooltip-arrow-left': this.arrowPosition === 'left',
                    'tooltip-arrow-right': this.arrowPosition === 'right'
                }
            }
        },
        methods: {
            open(method) {
                if (this.method !== method) {
                    return;
                }

                this.clearTimers();

                if (method !== 'hover') {
                    this.reveal();
                    return;
                }

                // Small delay before showing on hover to prevent flickering
                this.hoverTimeout = setTimeout(() => {
                    this.hoverTimeout = null;
                    this.reveal();
                }, 100);
            },
            reveal() {
                if (activeTooltip && activeTooltip !== this) {
                    activeTooltip.hideNow();
                }

                activeTooltip = this;
                this.show = true;
            },
            mouseleave() {
                this.clearTimers();

                // Quick hide
                this.hideTimeout = setTimeout(() => {
                    this.hideTimeout = null;
                    this.hideNow();
                }, 50);
            },
            hideNow() {
                this.clearTimers();
                this.show = false;

                if (activeTooltip === this) {
                    activeTooltip = null;
                }
            },
            clearTimers() {
                if (this.hoverTimeout) {
                    clearTimeout(this.hoverTimeout);
                    this.hoverTimeout = null;
                }

                if (this.hideTimeout) {
                    clearTimeout(this.hideTimeout);
                    this.hideTimeout = null;
                }
            }
        },
        beforeUnmount() {
            this.hideNow();
        }
    }
</script>

<style scoped>
.tooltip-arrow-left {
    margin-left: 0.75rem !important;
    margin-right: auto !important;
}

.tooltip-arrow-right {
    margin-left: auto !important;
    margin-right: 0.75rem !important;
}
</style>
